export default "__VITE_ASSET__hKxvEJ2g__"